
import { AuthService } from "@/services/Auth";
import Vue from "vue";

export default Vue.extend({
  name: "DatePickerHyper",
  props: {
    label: String,
    tag: String,
    placeholder: String,
    solo: Boolean,
    outlined: Boolean,
    disabled: Boolean,
    required: Boolean,
    rules: Array,
	value: {
      type: String,
      default: "",
    },    
    clearable: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      default: "40px",
    },
    months:{   
      type: Boolean,
      default: false,
    }, 
  },
  watch: {
    valor: {
      // immediate: true,
      handler(novoValor) {       
        this.$emit("input", novoValor);
      },
    },
    value: {
      immediate: true,
      handler(val) {  
        this.valor = val;

        //dd/MM/yyyy -> length=10
        if(val?.length == 10){
          //@ts-ignore
          $("#" + this.id).datepicker("setDate", val);
        }
        
      },
    },
  },
  data() {
    return {
      valor: "",
      id: "datepicker_" + Math.random().toString(16).slice(2),
      vMask:"##/##/####",
    };
  },
  mounted() {
    let user = AuthService.getUsuario();
    let language = 'es-ES';
    let formato_fecha = 'dd/mm/yyyy';

    if (user){
      language = user.language;
      formato_fecha = user.formato_fecha;      

      language = (null || undefined || '') ? 'es-ES' : language;
      formato_fecha = (null || undefined || '') ? 'dd/mm/yyyy' : formato_fecha.toLowerCase();
    }
    
    this.vMask = this.months ? "##/####" : this.vMask;

      //@ts-ignore
      $("#" + this.id).datepicker({
        language: language,
        autoclose: true,
        orientation: "bottom",      
        format: (this.months ? "mm/yyyy" : formato_fecha ),
        viewMode: (this.months ? "months" : "days"), 
        minViewMode: (this.months ? "months" : "days")
      });

      //@ts-ignore
      $("#" + this.id).change(() => {
        this.focus();
      });

      //@ts-ignore  
  },
  methods: {
    focus() {
      
      //@ts-ignore
      let val = $("#" + this.id).val();
      this.valor = val;

    },
  },
});
